import ApiService from '@/services/api.service'
import Store from '@/stores'
import { StatusCodes } from 'http-status-codes'
import AuthConstants from '@/constants/auth.constants'
import { UnexpectedServerError } from '@/exceptions/http.exceptions'
import { StorageService } from './storage.service'
import storageConstants from '../constants/storage.constants'

const AuthService = {
  registerUser: async function (email, password) {
    try {
      await ApiService.post('/auth/register', {
        email: email,
        password: password
      })
      StorageService.save(storageConstants.Email, email)
    } catch (error) {
      if (error.response.status === StatusCodes.CONFLICT) {
        throw new UserAlreadyExists(error.response.status, error.response.message)
      } else {
        throw new UnexpectedServerError(error.response.status, error.response.message)
      }
    }
  },
  loginUser: async function (email, password) {
    try {
      const response = await ApiService.post('/auth/login', {
          email: email,
          password: password
        }
      )
      if (response.status === StatusCodes.NO_CONTENT) {
        await Store.dispatch('auth/login')
        StorageService.save(storageConstants.Email, email)
      }
    } catch (error) {
      if (error.response.status === StatusCodes.UNAUTHORIZED) {
        Store.commit('auth/setLoginApiStatus', AuthConstants.LoginApiStatusFailed)

        throw new WrongCredentialsException(error.response.status, error.response.message)
      } if (error.response.status === StatusCodes.NOT_FOUND) {
        Store.commit('auth/setLoginApiStatus', AuthConstants.LoginApiStatusFailed)

        throw new UserNotFoundException(error.response.status, error.response.message)
      } if (error.response.status === StatusCodes.UNPROCESSABLE_ENTITY) {
        Store.commit('auth/setLoginApiStatus', AuthConstants.LoginApiStatusFailed)

        throw new AccountInactiveException(error.response.status, error.response.message)
      } else {
        Store.commit('auth/setLoginApiStatus', AuthConstants.LoginApiStatusFailed)

        throw new UnexpectedServerError(error.response.status, error.response.message)
      }
    }
  },
  logoutUser: async function () {
    try {
      Store.commit('auth/setLoginApiStatus', AuthConstants.LoginApiStatusLogout)
      StorageService.remove(storageConstants.Email)
    } catch (error) {
        throw new UnexpectedServerError(error.response.status, error.response.message)
    }
  },
  resetPassword: async function (email) {
    try {
      await ApiService.post('/auth/reset-password', {
        email: email
      })
    } catch (error) {
      if (error.response.status === StatusCodes.NOT_FOUND) {
        throw new UserNotFoundException(error.response.status, error.response.message)
      } else {
        throw new UnexpectedServerError(error.response.status, error.response.message)
      }
    }
  },
  validateSession: async function (sessionId) {
    try {
      await ApiService.post('/auth/reset-password/session/validate', {
        sessionId: sessionId
      })

      return true
    } catch (error) {
      throw new UnexpectedServerError(error.response.status, error.response.message)
    }
  },
  resetPasswordSend: async function (sessionId, password) {
    try {
      await ApiService.post('/auth/reset-password/send', {
        sessionId: sessionId,
        password: password
      })

      return true
    } catch (error) {
      throw new UnexpectedServerError(error.response.status, error.response.message)
    }
  },
  verifyRegister: async function (sessionId) {
    try {
      await ApiService.post('/auth/register/verify', {
        sessionId: sessionId
      })
    } catch (error) {
      throw new UnexpectedServerError(error.response.status, error.response.message)
    }
  }
}

class WrongCredentialsException extends Error {
  constructor (errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}
class AccountInactiveException extends Error {
  constructor (errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}
class UserNotFoundException extends Error {
  constructor (errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

class UserAlreadyExists extends Error {
  constructor (errorCode, message) {
    super(message)
    this.name = this.constructor.name
    this.message = message
    this.errorCode = errorCode
  }
}

export default AuthService

export { AuthService, WrongCredentialsException, AccountInactiveException, UserNotFoundException, UserAlreadyExists }
